import type { MarketingVoucherI18nFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (
	serverModel: ServerModel,
): MarketingVoucherI18nFormModel["InputModel"] => {
	const { voucherI18n } = serverModel;

	const inputModel: MarketingVoucherI18nFormModel["InputModel"] = {
		hotelID: voucherI18n.hotelID,
		voucherID: voucherI18n.voucherID,

		lang: voucherI18n.lang,

		name: voucherI18n.name,
		description: voucherI18n.description,
	} satisfies MarketingVoucherI18nFormModel["InputModel"];

	return inputModel;
};
